import { Component, Input } from '@angular/core';
import { BodyCell, IBodyCell } from '../../holders/body-cell.component';

@Component({
  selector: 'exi-button',
  template: `
      <button class="button" >{{ value }}</button>
  `,
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent<D> implements IBodyCell<D> {
   @Input() public cell: BodyCell<D>;
   @Input() public value: D;                                                                                           

}
